import { render, staticRenderFns } from "./ItemTypesPage.vue?vue&type=template&id=732f2902"
import script from "./ItemTypesPage.vue?vue&type=script&lang=js"
export * from "./ItemTypesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports